var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[_c('transition-group',{staticClass:"task-level-list"},_vm._l((_vm.levels),function(negLevel,index){return _c('b-link',{key:negLevel != null
              ? negLevel.id * 1000 + index
              : Math.trunc(Math.random() * 100000),class:{
            'test-card': true,
            locked: !negLevel.is_open,
            'test-one': index === 7,
            'test-two': index === 15,
            'test-three': index === 23,
            'card-second': index > 7,
            'card-third': index > 15,
          },attrs:{"disabled":!negLevel.is_open,"to":{
            name: negLevel.isLevel ? 'Task' : 'Test',
            params: { lid: negLevel.order },
          }}},[(negLevel.isLevel)?_c('div',{staticClass:"task-number"},[_vm._v(" "+_vm._s(negLevel.order)+" ")]):_vm._e(),(!negLevel.isLevel)?_c('div',{staticClass:"test-title",class:{
              test1: index == 7,
              test2: index == 15,
              test3: index == 23,
            }},[_vm._v(" Сорил ")]):_vm._e(),_c('div',{staticClass:"lock"},[_c('img',{attrs:{"src":require("../assets/images/lock.png"),"width":"30px"}})]),_c('div',{staticClass:"star-container"},_vm._l((3),function(i,index){return _c('div',{key:index},[_c('b-icon',{class:{
                  one: negLevel.rating === 1 && index === 0,
                  two: negLevel.rating === 2 && index < 2,
                  three: negLevel.rating === 3 && index < 3,
                },attrs:{"icon":"star-fill"}})],1)}),0)])}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }